import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'

export default {
  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    const institutionId = JSON.parse(localStorage.getItem('institution')).id

    const equipment = JSON.parse(sessionStorage.getItem('equipment'))
    if (equipment) {
      this.currentEquipment = equipment
      this.title = `do Equipamento - ${equipment.name}`
    }
    const contract = JSON.parse(sessionStorage.getItem('contract'))
    if (contract) {
      this.currentContract = contract
      this.title = `do Contrato - ${contract.number}`
    }
    const serviceOrder = JSON.parse(sessionStorage.getItem('serviceOrder'))
    if (serviceOrder) {
      this.currentServiceOrder = serviceOrder
      this.title = `da OS - ${serviceOrder.number}`
    }
    const calibrationPattern = JSON.parse(
      sessionStorage.getItem('calibrationPattern')
    )
    if (calibrationPattern) {
      this.currentCalibrationPattern = calibrationPattern
      this.title = `do Padrão ${calibrationPattern.name}`
      this.inputDisabled =
        this.institution.userType > 3 ||
        this.currentCalibrationPattern.institutionId != institutionId
    } else {
      this.inputDisabled =
        this.institution.userType > 3 && this.institution.userType != 8
    }

    this.filterTable()
  },

  data: () => ({
    title: '',
    institution: {},
    message: '',
    deleteDialog: false,
    dialogKey: false,
    loading: false,
    tableLoading: false,
    firstValid: true,
    showSuccess: false,
    inputDisabled: false,
    expanded: [],
    documents: [],
    currentEquipment: {},
    currentContract: {},
    currentServiceOrder: {},
    currentCalibrationPattern: {},
    currentDocument: {},
    userLogged: {},
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 10,
      equipmentId: null,
      contractId: null,
      serviceOrderId: null,
      calibrationPatternId: null,
    },
    referenceName: null,
    fileName: null,
    fileType: null,
    fileSize: null,
    fileData: null,
    uploadDate: null,
    headers: [
      {
        text: 'Nome',
        align: 'center',

        value: 'referenceName',
      },
      {
        text: 'Arquivo',
        align: 'center',

        value: 'fileName',
      },
      {
        text: 'Tipo',
        align: 'center',

        value: 'fileType',
        sortable: false,
      },
      {
        text: 'Tamanho',
        align: 'center',

        value: 'fileSize',
        sortable: false,
      },
      {
        text: 'Data',
        align: 'center',

        value: 'uploadDate',
        sortable: false,
      },
      {
        text: 'Ações',
        align: 'center',

        value: 'actions',
        sortable: false,
      },
    ],
    headersMobile: [
      {
        text: 'Arquivo',
        align: 'center',

        value: 'fileName',
      },
      {
        text: 'Ações',
        align: 'center',

        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
  }),

  methods: {
    close() {
      this.$router.go(-1)
    },

    importDocument() {
      if (this.$refs.firstForm.validate()) {
        this.loading = true
        var reader = new FileReader()
        reader.readAsDataURL(this.currentDocument)
        reader.onload = () => {
          this.fileData = reader.result
          this.upload()
        }
      }
    },

    getFile(document) {
      this.currentDocument = document
      this.getDocument()
    },

    deleteFile(document) {
      this.currentDocument = document
      this.dialogKey = !this.dialogKey
      this.deleteDialog = true
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },

    filterTable() {
      this.filter.equipmentId = this.currentEquipment.id
      this.filter.contractId = this.currentContract.id
      this.filter.serviceOrderId = this.currentServiceOrder.id
      this.filter.calibrationPatternId = this.currentCalibrationPattern.id
      this.updateTable()
    },

    async getDocument() {
      await this.apiService
        .get(`uploadDocument/${this.currentDocument.id}`)
        .then((response) => {
          const fileWindow = window.open()
          const url = 'data:application/pdf;base64,' + response.content

          fileWindow.document.write(
            `<html>
              <title>${this.currentDocument.fileName}.${
              this.currentDocument.fileType
            }</title>
              <body style:"overflow: hidden; margin: 0">
                <object width="100%" width="-webkit-fill-available" height="100%" height="-webkit-fill-available" type="application/pdf" data="${encodeURI(
                  url
                )}"></object>
              </body>
            </html>`
          )
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.currentDocument = {}
    },

    async updateTable() {
      this.tableLoading = true
      await this.apiService
        .post('uploadDocument/list', this.filter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.documents = response.content.documents
          this.tableLoading = false
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async upload() {
      const document = {
        Id: this.currentDocument != null ? this.currentDocument.id : null,
        EquipmentId:
          this.currentEquipment != null ? this.currentEquipment.id : null,
        ContractId: this.currentContract.id,
        ServiceOrderId: this.currentServiceOrder.id,
        CalibrationPatternId: this.currentCalibrationPattern.id,
        Name: this.referenceName,
        FileName: this.currentDocument.name,
        FileType: this.currentDocument.type.split('/')[1],
        Size: this.currentDocument.size,
        File: this.fileData,
      }

      await this.apiService
        .post('uploadDocument/add', document)
        .then((response) => {
          this.showSuccessAlert(response.message)
          this.loading = false
          this.$router.go()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
          this.loading = false
        })
    },

    async remove() {
      this.loading = true

      await this.apiService
        .delete('uploadDocument/delete', this.currentDocument)
        .then((response) => {
          this.showSuccessAlert(response.message)
          this.updateTable()
          this.loading = false
          this.deleteDialog = false
        })
        .catch(() => {
          this.loading = false
          this.deleteDialog = false
        })

      this.currentDocument = {}
    },

    showSuccessAlert(message) {
      this.message = message

      this.showSuccess = true

      setTimeout(() => {
        this.showSuccess = false
      }, 4000)
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },
  },
}
